import {VersionVariants} from './variants';

export {VersionVariants};
